var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"builder-header"},[_c('v-input',{attrs:{"size":"sm","placeholder":"Add a subject","model":_vm.action.subject},on:{"input":function($event){return _vm.updateSubject($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }